import groupBy from "lodash/groupBy.js";
import type { TSliceTableExtractions } from "../tableExtractions/sliceTableExtractions";
import type { ErrorRow } from "./createSelectorsTableMappings";
import type { TStateTableMappings } from "./sliceTableMappings";

export const createStandardizedTableErrorRows =
    () =>
    (state: {
        standardizedExtractionErrors: TSliceTableExtractions["extractionStandardizedErrors"];
        rowsDismissed: TStateTableMappings["rowsDismissed"];
    }): { [key: string]: ErrorRow[] } => {
        const errorRows = state.standardizedExtractionErrors;
        if (!errorRows) return {};

        const filteredErrorRows = errorRows.map(row => {
            if (
                state.rowsDismissed.find(
                    dismissedRow =>
                        dismissedRow.rowId === row.rowId &&
                        dismissedRow.periodId === row.periodId &&
                        dismissedRow.accountLabel === row.accountName,
                )
            ) {
                return {
                    ...row,
                    dismissed: true,
                };
            }
            return {
                ...row,
                dismissed: undefined,
            };
        });

        return groupBy(filteredErrorRows, error => {
            return [error.rowId, error.severity];
        });
    };
